import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'frontbucket.default.branch.deletion.title',
    description: 'Default branch deletion flag title',
    defaultMessage: 'Branch deletion on merge',
  },
  description: {
    id: 'frontbucket.default.branch.deletion.description',
    description: 'Default branch deletion flag description',
    defaultMessage:
      'You can now set the default for deleting the source branch. Users will be able to override \nwhen merging their pull requests.',
  },
});
